import { Stack, Switch, Typography } from "@mui/material";
import { useCallback } from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { isShowArgumentLabel } from "../../../../viewer/chart/style/argumentAxis/isShowArgumentLabel.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  readonlyMode: boolean;
}

export default function ShowLabelItem({ settings, readonlyMode }: Props) {
  const showLabel = isShowArgumentLabel(settings);
  const dispatch = useAppDispatch();

  const updateArgumentAxis = useCallback(
    (showLabel: boolean) => {
      dispatch(fieldsStateActions.updateAxisArgumentSettings({ showLabel }));
    },
    [dispatch]
  );

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Show Label</Typography>
      <HorizontalFill />
      <Switch checked={showLabel} disabled={readonlyMode} onChange={(_, value) => updateArgumentAxis(value)} />
    </Stack>
  );
}
